export default {
    "Pistol": {
        desc: "Стандартный пистолет .45 калибра, с магазином ёмкостью 12 патронов.",
        caliber: 0.45,
        img: 'Pistol.png',
        damage: 1,
        ratefire: 2,
        accuracy: 2,
        range: 1 
    },
    "Combat Pistol": {
        desc: "Компактный, легкий полуавтоматический пистолет, имеет магазин ёмкостью 12 патронов.",
        caliber: 0.45,
        img: 'CombatPistol.png',
        damage: 1,
        ratefire: 2,
        accuracy: 3,
        range: 1 
    },
    "Revolver": {
        desc: "Данный пистолет, обладает очень большой огневой мощностью также имеет барабан ёмкостью 6 патронов.",
        caliber: 0.44,
        img: 'Revolver.png',
        damage: 4,
        ratefire: 1,
        accuracy: 3,
        range: 2 
    },
    "Heavy Pistol": {
        desc: "Полуавтоматический пистолет, данный пистолет имеет очень хорошую точность, а также магазин ёмкостью 18 патронов.",
        caliber: 0.45,
        img: 'HeavyPistol.png',
        damage: 1,
        ratefire: 1,
        accuracy: 2,
        range: 2
    },
    "Bullpup Shotgun": {
        desc: "Компенсирует низкую скорострельность высокими дальностью стрельбы, разлётом дроби и убойной силой",
        caliber: 12,
        img: 'BullpupShotgun.png',
        damage: 2,
        ratefire: 2,
        accuracy: 2,
        range: 2 
    },
    "Combat PDW": {
        desc: "Бесшумный пистолет-пулемёт, обладает высокой точностью, мягкой отдачей, а также имеет магазин ёмкостью 30 патронов.",
        caliber: 9,
        img: 'CombatPDW.png',
        damage: 1,
        ratefire: 2,
        accuracy: 2,
        range: 2 
    },
    "Machine Pistol": {
        desc: "Полуавтоматический пистолет, имеет низкую точность, но владеет отличной пробивной силой, а также вместительный магазин.",
        caliber: 9,
        img: 'MachinePistol.png',
        damage: 1,
        ratefire: 4,
        accuracy: 2,
        range: 1
    },
    "Assault Rifle": {
        desc: "Стандартная штурмовая винтовка, может похвастаться хорошей точностью на большие расстояния.",
        caliber: 7.62,
        img: 'AssaultRifle.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Sniper Rifle": {
        desc: "Стандартная снайперская винтовка, идеально подходит для ситуаций, требующих точности на большой дистанции.",
        caliber: 7.62,
        img: 'SniperRifle.png',
        damage: 5,
        ratefire: 1,
        accuracy: 4,
        range: 5
    },
    "SNS Pistol": {
        desc: "Карманный пистолет, отлично подходит для перестрелок на небольших дистанциях, имеет магазин ёмкостью 6 патронов",
        caliber: 7.62,
        img: 'SNSPistol.png',
        damage: 1,
        ratefire: 2,
        accuracy: 2,
        range: 1
    },
    "Double Barrel Shotgun": {
        desc: "Двуствольный дробовик, наносит огромный урон на короткой дистанции. ",
        caliber: 7.62,
        img: 'DoubleBarrelShotgun.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 1
    },
    "SawnOff Shotgun": {
        desc: "Одноствольный дробовик, имеет малую дальность стрельбы и большим уроном в ближнем бою.",
        caliber: 7.62,
        img: 'SawnoffShotgun.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 1
    },
    "Micro SMG": {
        desc: "Малогабаритный пистолет - пулемёт, имеет не очень большой урон, но его скорострельность это компенсирует.",
        caliber: 7.62,
        img: 'MicroSMG.png',
        damage: 1,
        ratefire: 3,
        accuracy: 1,
        range: 1
    },
    "Pump Shotgun": {
        desc: "Стандартный помповый дробовик, имеет низкую точность попадания и магазин ёмкостью 8 патронов.",
        caliber: 7.62,
        img: 'PumpShotgun.png',
        damage: 3,
        ratefire: 1,
        accuracy: 1,
        range: 1
    },
    "SMG": {
        desc: "Универсальный пистолет - пулемет, легкий с очень точным прицелом, имеет магазин ёмкостью 30 патронов.",
        caliber: 7.62,
        img: 'SMG.png',
        damage: 1,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Mini SMG": {
        desc: "Малогабаритный пистолет - пулемёт, имеет магазин ёмкостью 20 патронов.",
        caliber: 7.62,
        img: 'MiniSMG.png',
        damage: 1,
        ratefire: 4,
        accuracy: 2,
        range: 1
    },
    "Advanced Rifle": {
        desc: "Усовершенствованная винтовка, является самой компактной из всех штурмовых винтовок, имеет магазин ёмкостью 30 патронов.",
        caliber: 7.62,
        img: 'AdvancedRifle.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Pistol 50": {
        desc: "Ударопрочный пистолет, который имеет огромную мощность, имеет магазин ёмкостью 9 патронов.",
        caliber: 7.62,
        img: 'Pistol50.png',
        damage: 2,
        ratefire: 2,
        accuracy: 3,
        range: 2
    },
    "Compact Rifle": {
        desc: "Укороченная винтовка, схожая со штурмовыми винтовками. Отличается повышенным уроном и магазином ёмкостью 30 патронов.",
        caliber: 7.62,
        img: 'CompactRifle.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Vintage Pistol": {
        desc: "Винтажный пистолет, выделяется среди других пистолетов своёй гравировкой, имеет магазин ёмкостью 7 патронов..",
        caliber: 7.62,
        img: 'VintagePistol.png',
        damage: 2,
        ratefire: 2,
        accuracy: 2,
        range: 1
    },
    "Up-n-Atomizer": {
        desc: "Футуристичный пистолет, по внешнему виду похож на инопланетный пистолет, не требует боеприпасов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 4,
        ratefire: 1,
        accuracy: 1,
        range: 2
    },
    "Ceramic Pistol": {
        desc: "Керамический пистолет, обойма вмещает в себя 12 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 2,
        accuracy: 2,
        range: 1
    },
    "Navy Revolver": {
        desc: "Армейский револьвер, обойма вмещает в себя 6 патрон.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 1,
        accuracy: 3,
        range: 2
    },
    "Unholy Hellbringer": {
        desc: "Футуристичная плазменная винтовка, имеет необычный внешний вид.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 3,
        accuracy: 2,
        range: 3
    },
    "Grenade Launcher": {
        desc: "Легкий гранатомёт с полуавтоматическим функционалом, вмещает в себя до 10 боеприпасов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 2
    },
    "RPG": {
        desc: "Ручной противотанковый гранатомёт, вмещает в себя 1 боеприпас.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 3
    },
    "Minigun": {
        desc: "6-стовольный пулемет, имеет очень высокую скорострельность, а также вмещает в себя 595 боеприпасов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 5,
        accuracy: 2,
        range: 3
    },
    "Firework Launcher": {
        desc: "Пусковая установка для запуска фейерверков, поможет поднять настроение или устроить праздник.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 1,
        accuracy: 1,
        range: 3
    },
    "Railgun": {
        desc: "Рельсовое тяжелое оружие, имеет большой урон, а также вмещает в себя до 20 боеприпасов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 3
    },
    "Homing Launcher": {
        desc: "Ракетная установка с инфракрасным наведением на цель, вмещает в себя 1 боеприпас.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 4
    },
    "Grenade Launcher Smoke": {
        desc: "Легкий гранатомёт, запускает вместо обычных гранат дымовые.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 0,
        ratefire: 1,
        accuracy: 1,
        range: 3
    },
    "Compact Grenade Launcher": {
        desc: "Компактный гранатомёт, вмещает в себя всего 1 боеприпас.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 1,
        range: 3
    },
    "Widowmaker": {
        desc: "Футуристичный плазменый пулемет, вмещает в себя до 9999 боеприпасов",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 5,
        accuracy: 2,
        range: 3
    },
    "Marksman Pistol": {
        desc: "Марксманский пистолет, обойма вмещает в себя 1 патрон.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 4,
        ratefire: 1,
        accuracy: 12,
        range: 2
    },
    "AP Pistol": {
        desc: "Бронебойный пистолет, обойма вмещает в себя 18 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 4,
        accuracy: 2,
        range: 1
    },
    "Stun Gun": {
        desc: "Электрошоковое оружие, обойма вмещает в себя 1 заряд.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 0,
        ratefire: 1,
        accuracy: 2,
        range: 1
    },
    "Flare Gun": {
        desc: "Сигнальный пистолет.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 1,
        accuracy: 1,
        range: 1
    },
    "Double Action Revolver": {
        desc: "Самовзводный револьвер, обойма вмещает в себя 6 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 2,
        accuracy: 3,
        range: 1
    },
    "Pistol Mk2": {
        desc: "Улучшенная версия обычного пистолета, обойма вмещает в себя 12 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 2,
        accuracy: 2,
        range: 1
    },
    "SNSPistol Mk2": {
        desc: "лучшенная версия карманного пистолета, обойма вмещает в себя 6 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 2,
        accuracy: 2,
        range: 1
    },
    "Heavy Revolver Mk2": {
        desc: "Улучшенная версия стандартного револьвера, обойма вмещает в себя 6 патронов",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 4,
        ratefire: 1,
        accuracy: 3,
        range: 2
    },
    "MG": {
        desc: "Тяжелый пулемет, обойма вмещает в себя 54 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 3
    },
    "Combat MG": {
        desc: "Пулемёт специального назначения, обойма вмещает в себя 100 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 3,
        accuracy: 2,
        range: 3
    },
    "Gusenberg": {
        desc: "Пистолет - пулемет, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 3
    },
    "SMG Mk2": {
        desc: "Улучшенный пистолет-пулемёт, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Combat MG Mk2": {
        desc: "Обновлённый единый пулемёт, вмещает в себя 100 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 3,
        accuracy: 2,
        range: 3
    },
    "Carbine Rifle": {
        desc: "Американская полуавтоматическая винтовка, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 3,
        range: 2
    },
    "Special Carbine": {
        desc: "Штурмовая винтовка с меньшей отдачей, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 3,
        range: 2
    },
    "Special Carbine Mk2": {
        desc: "Улучшеная полуавтоматическая винтовка, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 3,
        range: 2
    },
    "Bullpup Rifle": {
        desc: "Китайская штурмовая винтовка, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Bullpup Rifle Mk2": {
        desc: "Улучшеная штурмовая винтовка из Китая, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 4,
        accuracy: 2,
        range: 2
    },
    "Assault Rifle Mk2": {
        desc: "Улучшенная штурмовая винтовка, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Carbine Rifle Mk2": {
        desc: "Улучшеная полуавтоматическая винтовка, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 3,
        range: 2
    },
    "Bullpup Rifle Mk2": {
        desc: "Улучшеная штурмовая винтовка из Китая, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 2,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Heavy Sniper": {
        desc: "Крупнокалиберная снайперская винтовка, обойма вмещает в себя 6 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 4,
        range: 5
    },
    "Heavy Sniper Mk2": {
        desc: "Улучшенная крупнокалиберная снайперская винтовка, обойма вмещает в себя 6 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 4,
        range: 5
    },
    "Marksman Rifle": {
        desc: "Улучшенная марксманская снайперская винтовка, обойма вмещает в себя 8 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 2,
        accuracy: 4,
        range: 4
    },
    "Assault Shotgun": {
        desc: "Штурмовой дробовик, обойма вмещает в себя 8 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 4,
        ratefire: 2,
        accuracy: 1,
        range: 1
    },
    "Musket": {
        desc: "Ручное огнестрельное оружие, обойма вмещает в себя 1 патрон.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 5,
        ratefire: 1,
        accuracy: 3,
        range: 4
    },
    "Heavy Shotgun": {
        desc: "Тяжелый шестизарядный дробовик, обойма вмещает в себя 6 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 4,
        ratefire: 2,
        accuracy: 1,
        range: 1
    },
    "Sweeper Shotgun": {
        desc: "Компактный скорострельный дробовик, обойма вмещает в себя 10 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 2,
        accuracy: 1,
        range: 1
    },
    "Pump Shotgun Mk2": {
        desc: "Улучшенный помповый дробовик, обойма вмещает в себя 8 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 3,
        ratefire: 1,
        accuracy: 1,
        range: 1
    },
    "Assault SMG": {
        desc: "Штурмовое автоматическое оружие, обойма вмещает в себя 30 патронов.",
        caliber: 7.62,
        img: 'NeedName.png',
        damage: 1,
        ratefire: 3,
        accuracy: 2,
        range: 2
    },
    "Бронежилет": {
        desc: "Служит средством защиты персонажа, способен впитать урон прежде чем сломается.",
        caliber: 0,
        img: '',
        damage: 0,
        ratefire: 0,
        accuracy: 0,
        range: 0
    },
    "Аптечка": {
        desc: "Восстанавливает здоровье персонажа до максимума. Можно использовать 1 раз в 10 секунд.",
        caliber: 0,
        img: '',
        damage: 0,
        ratefire: 0,
        accuracy: 0,
        range: 0
    },
    "Бинт": {
        desc: "Восстанавливает 40% здоровья. Можно использовать раз в несколько секунд. Крафтится стаком по 10 штук.",
        caliber: 0,
        img: '',
        damage: 0,
        ratefire: 0,
        accuracy: 0,
        range: 0
    },
    "Бронепластина": {
        desc: "Ремонтирует бронежилет до его изначальной прочности. Нельзя использовать без бронежилета или если он уже полный.",
        caliber: 0,
        img: '',
        damage: 0,
        ratefire: 0,
        accuracy: 0,
        range: 0
    },
};